module.exports = __webpack_public_path__ + "img/map-tr-small.058fb919.svg";